import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PreloaderService {
  isLoading = true; // Controls the fade animation
  showPreloader = false; // Controls DOM presence

  triggerPreloader() {
    this.showPreloader = true; // Show preloader
    this.isLoading = true; // Start fade-in
  }

  hidePreloader() {
    setTimeout(() => {
      this.isLoading = false; // Start fade-out

      const preloaderEl = document.getElementById('preloader');
      if (preloaderEl) {
        preloaderEl.addEventListener(
          'transitionend',
          () => {
            this.showPreloader = false; // remove from DOM
          },
          { once: true }
        );
      }
    }, 1000);
  }
}
